<template>
  <div :id="id"></div>
  <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'light'"
  />
  <img
    src="@/assets/images/pie-chart-bg.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'medium'"
  />
  <img
    src="@/assets/images/pie-chart-bg-dark.svg"
    alt="#"
    class="pie-chart-bg"
    v-if="theme == 'dark'"
  />
</template>

<script>
import store from "@/store";

import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
highchartsMore(Highcharts);
solidGauge(Highcharts);


export default {
  name: "CircularPieFilterV3",
  props: ["id","pieChartData"],
  data() {
    return {
      path: this.$route.path
    }
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    },
  },
  
   updated() {
   this.renderChart();
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart: function () {
      Highcharts.chart(this.id, {
        chart: {
          backgroundColor: "transparent",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
          height: "250px",
        },
        title: null,
        yAxis: [
          {
            min: 0,
            max: 10,
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickPixelInterval: 200,
            labels: {
              y: -17,
              distance: 10,
              style: { fontSize: "0.4rem", color: "#41C9BB" },
            },
            title: {
              text: "Score",
              style: { color: "#859392", fontSize: "0.7rem" },
              y: 90,
            },
          },
          {
            linkedTo: 0,
            offset: -27,
            tickInterval: 0.4,
            tickLength: 2,
            tickColor: "#297971",
            tickWidth: 2,
            minorTickInterval: null,
            lineWidth: 0,
            labels: { enabled: !1 },
          },
        ],
        plotOptions: {
          pie: {
            borderWidth: 4,
            borderColor: this.theme == 'light' || this.theme =='medium' ? "#fff" : "#071D1D",
            center: ["50%", "50%"],
            allowPointSelect: true,
            cursor: "pointer",
            size: "60%",
            slicedOffset: 0,
            color: "red",
            fillColor: "red",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>",
              connectorColor: "silver",
              color: "#4a7780",
            },
          },
        },
        tooltip: {
          enabled: false,
          formatter: function () {
            return "<b>" + this.point.name + "</b>: " + this.y + " %";
          },
        },
        series: [
          {
            animation: {
              duration: 1500
            },
            data: [
              {
                name: "حسب المخطط",
                y: this.pieChartData.onplanned,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#AAFFA9"], /// start
                    [1, "#AAFFA9"], // end
                  ],
                },
                dataLabels: {
                  connectorColor: this.theme=='light' || this.theme=='medium' ? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium'? 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'> اﻟﻤﺨﻄﻂ<span class='cust-label' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.pieChartData.onplanned}</span></div>` :
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'> اﻟﻤﺨﻄﻂ<span class='cust-label' style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.pieChartData.onplanned}</span></div>`
                    ,
                },
                events: {
                    click: (function() {

                        if(this.path == '/sector-detail') {
                          store.dispatch('setFilteredSectorProjects',store.getters.getSectorProjects.filter((item) => item.ProjectStatus == 'حسب المخطط'));
                          store.dispatch('setActiveTabSector','حسب المخطط');
                        } else {
                          store.dispatch('setFilteredProjects',store.getters.getProjects.filter((item) => item.ProjectStatus == 'حسب المخطط'));
                          store.dispatch('setActiveTab','حسب المخطط');
                        }
                        window.scrollTo({
                            top: document.getElementById('databased-row').offsetTop,
                            behavior: 'smooth'
                        });

                    }).bind(this)
                }
              },
              {
                name: "تم الاطلاق(مكتمل)",
                y: this.pieChartData.completed,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#48B0C4"], /// start
                    [1, "#48B0C4"], // end
                  ],
                },
                dataLabels: {
                  connectorColor: this.theme=='light' || this.theme=='medium'? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme=='light' || this.theme =='medium'? 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important; '>ﻣﻜﺘﻤﻞ <span class='cust-label left'style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.pieChartData.completed}</span></div>`:
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important; '>ﻣﻜﺘﻤﻞ <span class='cust-label left'style='background-color:#103C64;border:0px solid #1B6371;color:#fff'>${this.pieChartData.completed}</span></div>`
                    ,
                },
                events: {
                    click: (function() {
                       if(this.path == '/sector-detail') {
                          store.dispatch('setFilteredSectorProjects',store.getters.getSectorProjects.filter((item) => item.ProjectStatus == 'تم الاطلاق(مكتمل)'));
                          store.dispatch('setActiveTabSector','تم الاطلاق(مكتمل)');
                        } else {
                          store.dispatch('setFilteredProjects',store.getters.getProjects.filter((item) => item.ProjectStatus == 'تم الاطلاق(مكتمل)'));
                          store.dispatch('setActiveTab','تم الاطلاق(مكتمل)');
                        }
                        

                        window.scrollTo({
                            top: document.getElementById('databased-row').offsetTop,
                            behavior: 'smooth'
                        });
                    }).bind(this)
                }
              },
              {
                name: "متأخر",
                y: this.pieChartData.late,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#FF7D54"], /// start
                    [1, "#FF7D54"], // end
                  ],
                },
                dataLabels: {
                  connectorColor:  this.theme=='light' || this.theme =='medium'? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium'?
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'>متأخر <span class='cust-label left' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.pieChartData.late}</span></div>` : 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'>متأخر <span class='cust-label left' style='background-color:#103C64;0px solid #1B6371;color:#fff'>${this.pieChartData.late}</span></div>`
                    ,
                },
                events: {
                    click: (function() {
                      if(this.path == '/sector-detail') {
                          store.dispatch('setFilteredSectorProjects',store.getters.getSectorProjects.filter((item) => item.ProjectStatus == 'متأخر'));
                          store.dispatch('setActiveTabSector','متأخر');
                        } else {
                           store.dispatch('setFilteredProjects',store.getters.getProjects.filter((item) => item.ProjectStatus == 'متأخر'));
                           store.dispatch('setActiveTab','متأخر');
                        }
                       

                        window.scrollTo({
                            top: document.getElementById('databased-row').offsetTop,
                            behavior: 'smooth'
                        });
                    }).bind(this)
                }
              },
              {
                name: "ﻣﺘﻮﻗﻊ اﻟﺘﺄﺧﯿﺮ",
                y: this.pieChartData.expectedLate,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#FFB627"], /// start
                    [1, "#FFB627"], // end
                  ],
                },
                dataLabels: {
                  connectorColor:  this.theme=='light' || this.theme=='medium'? "#90B2B9" : "#91B3BA",
                  distance: 10,
                  useHTML: true,
                  format:
                    this.theme == 'light' || this.theme =='medium'?
                    `<div class='cust-chart-datalabel' style='position:relative;color:#527A7A !important;'>ﻣﺘﻮﻗﻊ اﻟﺘﺄﺧﯿﺮ <span class='cust-label left' style='background-color:transparent;border:1px solid #00BABE;color:#153E39'>${this.pieChartData.expectedLate}</span></div>` : 
                    `<div class='cust-chart-datalabel' style='position:relative;color:#1B6371 !important;'>ﻣﺘﻮﻗﻊ اﻟﺘﺄﺧﯿﺮ <span class='cust-label left' style='background-color:#103C64;0px solid #1B6371;color:#fff'>${this.pieChartData.expectedLate}</span></div>`
                    ,
                },
                events: {
                    click: (function() {
                       if(this.path == '/sector-detail') {
                          store.dispatch('setFilteredSectorProjects',store.getters.getSectorProjects.filter((item) => item.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'));
                          store.dispatch('setActiveTabSector','متوقع التأخير/ملاحظة مهمة');
                        } else {
                          store.dispatch('setFilteredProjects',store.getters.getProjects.filter((item) => item.ProjectStatus == 'متوقع التأخير/ملاحظة مهمة'));
                          store.dispatch('setActiveTab','متوقع التأخير/ملاحظة مهمة');
                        }
                       

                        window.scrollTo({
                            top: document.getElementById('databased-row').offsetTop,
                            behavior: 'smooth'
                        });
                    }).bind(this)
                }
              },
            ],
            size: "65%",
            innerSize: "75%",
            showInLegend: false,
            dataLabels: {
              enabled: true,
            },
          },
        ],
      });
      document
      .querySelectorAll(".highcharts-credits")
      .forEach((item) => (item.style.display = "none"));
    },

  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";
body.theme-light {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;

  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;

  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
body.theme-medium {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;

  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;

  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
body.theme-dark {
  .pie-chart-bg {
    position: absolute;
    top: 149px;
    z-index: 0;
  }
  #cirpie1,
  #cirpie2,
  #cirpie3,
  #cirpie4 {
    width: 380px !important;
    height: 250px !important;
    margin-top: 18px;

  }
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
</style>